import { storageName } from "@baton/core/src/storage/names.ts";

/**
 * 001 FR-153 as amended 2026-09-29: a signed-in person who verifies on the public entry's page lands
 * in the application with the toast the page used to raise itself, "Your email address is verified"
 * or "…is already verified". The two pages are separate documents, so the outcome crosses the full
 * load in the tab's session storage, which the application's entry reads once and clears. A browser
 * that refuses session storage lands with no toast, and the banner's absence still says it.
 */
export type VerifiedLanding = "verified" | "already";

const KEY = storageName("verified-landing");

function sessionStore(): Storage | null {
  try {
    const store = window.sessionStorage;
    store.setItem(KEY, store.getItem(KEY) ?? "");
    return store;
  } catch {
    return null;
  }
}

/** Keep the outcome for the application's entry, which the public page leaves for next. */
export function markVerifiedLanding(outcome: VerifiedLanding): void {
  sessionStore()?.setItem(KEY, outcome);
}

/** The outcome a public page left for this load, read once. */
export function takeVerifiedLanding(): VerifiedLanding | null {
  const store = sessionStore();
  const value = store?.getItem(KEY) ?? null;
  store?.removeItem(KEY);
  return value === "verified" || value === "already" ? value : null;
}
